import {Record as record} from 'immutable';

export default record(
    {
        unveiled: false,
        lat: 30.26,
        lng: 97.74,
        apiKey: 'AIzaSyC4bdGONQqPkVvq12f8q1GgR-ZW3rXU8vo',
        propertyMapThumbnailUrl: 'http://www.vrbo.com/path/to/img/url',
        language: 'en_US',
        region: 'US',
        labels: {},
        locationDescription: ''
    },
    'MapRecord'
);
